import { api } from '../index';

const prefix = '/api/shipment/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectShipmentList(param) {
	return api.post(prefix + 'selectShipmentList', param);
}

export function apiSelectShipmentItemList(param) {
	return api.get(prefix + 'selectShipmentItemList', { params: param });
}

export function apiSelectShipment(param) {
	return api.post(prefix + 'selectShipment', param);
}
export function apiFindShipmentList(param) {
	return api.post(prefix + 'list', param);
}

export function apiCheckShipmentExists(param) {
	return api.post(prefix + 'checkShipmentExists', param);
}

export function apiInsertShipment(param) {
	param.mode = 'insert';
	return apiSubmitShipment(param);
}

export function apiUpdateShipment(param) {
	param.mode = 'update';
	return apiSubmitShipment(param);
}

export function apiDeleteShipment(param) {
	param.mode = 'delete';
	return apiSubmitShipment(param);
}

function apiSubmitShipment(param) {
	return api.post(prefix + 'submitShipment', param);
}

export function apiUpdateShipmentArrivalDate(param) {
	return api.post(prefix + 'updateShipmentArrivalDate', param);
}

export function apiUpdateShipmentStatus(param) {
	return api.post(prefix + 'updateShipmentStatus', param);
}
